var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact text-center mt-5 mb-5",staticStyle:{"width":"100%"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSfydqIxUj5RVuDu-zEnZiFR1cutLJSQ4syB9WCBIXjRsop8cQ/viewform?embedded=true","width":"640","height":"884","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("読み込んでいます…")])])
}]

export { render, staticRenderFns }